import React, { useState } from "react";
import { toast } from "react-toastify";

// JS Files
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import MuiComboBox from "../../../shares/MuiComboBox";
import { useLocation } from "react-router-dom";
import { useProducerBasket } from "../../../../context/ProducerBasketContext";

const PTabZero = (props) => {
  const { userData } = useUserData();
  const location = useLocation();
  const { createHistoryBasket } = useProducerBasket();

  const [searchedCustomerText, setSearchedCustomerText] = useState(
    location.state != null ? location.state.userInfo.username : ""
  );
  const [adminCustomersList, setAdminCustomersList] = useState([]);
  console.log(location.state);
  const getListOfCustomerApi = useFetch({
    method: "get",
    url: `Provider_Service/get_providers`,
    params: { name: searchedCustomerText },
    trigger: location.state != null ? true : true,
    argFunc: (res) => {
      setAdminCustomersList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handleSearchedCustomerText = (text) => {
    setSearchedCustomerText(text);
    if (text.length >= 1) {
      getListOfCustomerApi.reFetch();
    }
  };

  return (
    <>
      {props.selectedUser !== undefined ? (
        <div className="mb-4">
          <span className="text-myblue-100">
            تولیدکننده انتخاب شده:{" "}
            <span className="text-gray-700">{props.selectedUser?.name}</span>
          </span>
        </div>
      ) : (
        ""
      )}

      <div className="grid md:grid-cols-3 gap-x-4 items-center mt-4">
        <span className="">تولیدکننده را انتخاب کنید:</span>
        <MuiComboBox
          size="small"
          label="تولیدکننده"
          labelId="customer-search-label"
          id="customer-search-select"
          selectedUser={props.selectedUser}
          setSelectedUser={props.setSelectedUser}
          options={adminCustomersList}
          placeholder="نام تولیدکننده"
          setSelectedOption={props.setSelectedCustomer}
          setSearchText={handleSearchedCustomerText}
          forProvider
          baseWithJustUser
          selectedOption={props.selectedCustomer}
        />
      </div>
    </>
  );
};

export default PTabZero;
